import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthPageShell from "../components/AuthPageShell";

const API_BASE = process.env.REACT_APP_API_URL || "";

export default function Forgot() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");

    async function onSubmit(e) {
        e.preventDefault();
        const res = await fetch(`${API_BASE}/api/password/forgot`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ email }),
        });
        setMessage(res.ok ? "Если такой Email существует, ссылка для сброса отправлена" : "Ошибка");
        setMessageType(res.ok ? "success" : "error");
    }

    return (
        <AuthPageShell>
            <h1 className="auth-page-title">Забыли пароль</h1>
            <form onSubmit={onSubmit} className="auth-form">
                <input
                    placeholder="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="ui-input"
                    required
                />
                <button className="toolbar-btn" type="submit">
                    Отправить ссылку для сброса
                </button>
            </form>
            <div className="auth-links">
                <Link to="/login" className="btn-outline">Назад ко входу</Link>
            </div>
            {message && (
                <p className={messageType === "success" ? "form-message--success" : "form-message"}>
                    {message}
                </p>
            )}
        </AuthPageShell>
    );
}
